module.exports = __webpack_public_path__ + "img/zambia.990f7ec8.png";